module.exports = __webpack_public_path__ + "static/p-dinda-2-f6a915e41adfa283a88401fc494a8051.jpg";